import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckIcon } from '../../assets/icons/svg/colored-icons/ic-colored-success-new.svg';
import NoticeModal from '../../DesignSystem/NoticeModal/NoticeModal';

export interface ChangeEmailProps {
  newEmail: string;
  onSubmit: () => void;
  isLoadingLogOut: boolean;
}

export const ChangeEmailSuccess = ({ newEmail, onSubmit, isLoadingLogOut }: ChangeEmailProps) => {
  const { t } = useTranslation();
  const title = t('CHANGE_EMAIL.SUCCESS.TITLE');

  const content = (
    <div className='flex flex-col justify-center items-center pb-[21px] '>
      <p className='font-metricSemibold text-gray-700 text-center text-[20px] mb-[8px] ' id='newEmailSuccess'>
        {newEmail}
      </p>
      <div className='w-[300px]' id='disclaimer'>
        <p className='text-bw08 text-sm font-metricR mb-[8px] text-center' id='disclaimer1'>
          {t('CHANGE_EMAIL.SUCCESS.SMALL_TEXT').split('\n')[0]}
        </p>
        <p className='text-bw08 text-sm font-metricR text-center pb-4' id='disclaimer2'>
          {t('CHANGE_EMAIL.SUCCESS.SMALL_TEXT').split('\n')[1]}
        </p>
      </div>
    </div>
  );

  return (
    <NoticeModal
      isButtonLoading={isLoadingLogOut}
      onClickOutside={onSubmit}
      buttonText={t('CHANGE_EMAIL.SUCCESS.SUBMIT_BUTTON')}
      title={title}
      id='id'
      image={<CheckIcon className='w-12/12 stroke-action0 text-action03' />}
      content={content}
      onSubmit={onSubmit}
      shouldBlur
    />
  );
};
